import { ButtonMantine, Center, Group, Modal, Stack, Text, ThemeIcon } from 'ui';
import { IconCircleCheck } from 'ui/Icons';

import { useLogActivityModalProvider } from './LogActivityModalFlow';

const LogActivitySuccessModal = () => {
  const { opened, close, openModalById } = useLogActivityModalProvider({
    id: 'success',
  });
  return (
    <Modal.Root opened={opened} onClose={close}>
      <Modal.Overlay />
      <Modal.Content>
        <Modal.Header>
          <Center w="100%" pt="lg">
            <ThemeIcon size={64} variant="transparent" color="mint.7">
              <IconCircleCheck size={64} />
            </ThemeIcon>
          </Center>
        </Modal.Header>
        <Modal.Body p="lg">
          <Stack gap="xs">
            <Text fz="lg" fw={600}>
              Activity has been logged!
            </Text>
            <Text fz="sm" c="gray">
              Keep up the great work.
            </Text>
          </Stack>
          <Modal.AffixedFooter>
            <Group gap="sm" grow>
              <ButtonMantine variant="subtle" onClick={() => openModalById('base')}>
                Log More Activity
              </ButtonMantine>
              <ButtonMantine onClick={close}>Close</ButtonMantine>
            </Group>
          </Modal.AffixedFooter>
        </Modal.Body>
      </Modal.Content>
    </Modal.Root>
  );
};

export { LogActivitySuccessModal };
